<template>
    <span v-if="value === 'gph'" class="employee-hiring-badge"
          :title="showTooltip ? 'Форма найма: ГПХ' : null" aria-label="Форма найма: ГПХ">ГПХ</span>
</template>
<script>
export default {
    name: 'EmployeeHiringBadge',
    props: {
        value: {type: String, default: null},
        showTooltip: {type: Boolean, default: true}
    }
};
</script>
<style scoped>
.employee-hiring-badge {
    display: inline-block;
    flex: 0 0 auto;
    margin-left: 4px;
    padding: 0 3px;
    border-radius: 3px;
    color: #4a5568;
    background: #edf0f4;
    font-size: inherit;
    font-weight: 600;
    line-height: inherit;
    white-space: nowrap;
    vertical-align: baseline;
}
</style>
